<template>
    <div class="panel-content">
        <h3>Endereço</h3>
         <form @submit.prevent="save">
            <div class="row">
                <div class="col-3">
                    <div class="form-group" :class="{ 'form-group--error': $v.country.$error }">
                        <input class="form__input" id="country" v-model.trim="$v.country.$model"/>
                        <label class="form__label" for="country" :class="{'up': $v.country.$model }">País</label>
                        <div class="error" v-if="!$v.country.required">País é obrigatório</div>
                    </div>
                </div>
                <div class="col-9">

                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="form-group" :class="{ 'form-group--error': $v.zipcode.$error }">
                        <input class="form__input" id="zipcode" v-model.trim="$v.zipcode.$model"/>
                        <label class="form__label" for="zipcode" :class="{'up': $v.zipcode.$model }">CEP</label>
                        <div class="error" v-if="!$v.zipcode.required">CEP é obrigatório</div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="form-group" :class="{ 'form-group--error': $v.address.$error }">
                        <input class="form__input" id="address" v-model.trim="$v.address.$model"/>
                        <label class="form__label" for="address" :class="{'up': $v.address.$model }">Endereço</label>
                        <div class="error" v-if="!$v.address.required">Endereço é obrigatório</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <div class="form-group" :class="{ 'form-group--error': $v.number.$error }">
                        <input class="form__input" id="number" v-model.trim="$v.number.$model"/>
                        <label class="form__label" for="number" :class="{'up': $v.number.$model }">Número</label>
                        <div class="error" v-if="!$v.number.required">Número é obrigatório</div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <input class="form__input" id="complement" v-model.trim="complement"/>
                        <label class="form__label" for="complement" :class="{'up': complement }">Complemento</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group" :class="{ 'form-group--error': $v.district.$error }">
                        <input class="form__input" id="district" v-model.trim="$v.district.$model"/>
                        <label class="form__label" for="district" :class="{'up': $v.district.$model }">Bairro</label>
                        <div class="error" v-if="!$v.district.required">Bairro é obrigatório</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group" :class="{ 'form-group--error': $v.city.$error }">
                        <input class="form__input" id="city" v-model.trim="$v.city.$model"/>
                        <label class="form__label" for="city" :class="{'up': $v.city.$model }">Cidade</label>
                        <div class="error" v-if="!$v.city.required">Cidade é obrigatório</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group" :class="{ 'form-group--error': $v.state.$error }">
                        <input class="form__input" id="state" v-model.trim="$v.state.$model"/>
                        <label class="form__label" for="state" :class="{'up': $v.state.$model }">Estado</label>
                        <div class="error" v-if="!$v.state.required">Estado é obrigatório</div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <button class="button" type="submit" :disabled="submitStatus === 'PENDING'">Salvar alterações</button>
                <button class="white">Cancelar alterações</button>
            </div>

            <!-- <p class="typo__p" v-if="submitStatus === 'OK'"></p> -->
            <p class="typo__p" v-if="submitStatus === 'ERROR'">Por favor, preencha todos os campos corretamente.</p>
            <p class="typo__p" v-if="submitStatus === 'PENDING'">Processando...</p>
        </form>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: "Address",
    data(){
        return {
            submitStatus: null,
            address: "",
            city: "",
            complement: "",
            country: "",
            district: "",
            number: "",
            state: "",
            zipcode: ""
        }
    },
    validations: {
        address: {
            required
        },
        city: {
            required
        },
        country: {
            required
        },
        district: {
            required
        },
        number: {
            required
        },
        state: {
            required
        },
        zipcode: {
            required,
        }
    },
    methods: {
        save(){

        }
    },
    
}
</script>